import React from "react";
import { Dropdown } from "../ui/Dropdown";
import { Button } from "../ui/Button";

export const MaterialButtons = ({ items, activeItem, setActiveItem }) => {
  return (
    <div class="styling-wrap__type-items poppins-18-500">
      {items &&
        items.map((item) => {
          if (item.materials.length > 1) {
            return (
              <Dropdown
                activeItem={activeItem}
                setActiveItem={setActiveItem}
                heading={item.name}
                items={item.materials}
              />
            );
          } else {
            return (
              <Button
                activeItem={activeItem}
                setActiveItem={setActiveItem}
                item={item.materials[0]}
              />
            );
          }
        })}
    </div>
  );
};
